import { render, staticRenderFns } from "./OrganizationFilePatcher.vue?vue&type=template&id=ef5321d2"
import script from "./OrganizationFilePatcher.vue?vue&type=script&lang=ts"
export * from "./OrganizationFilePatcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports